import React from 'react'
import { Header2, LinkButton } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../../helpers'

const APP_STORE_URL = 'https://apps.apple.com/us/app/glamsquad/id766676007'

const BookCTAWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 120px 88px;
  gap: 40px;

  ${mq('max', '768px')} {
    padding: 72px 16px;
    gap: 32px;
  }

  .cta-buttons {
    display: flex;
    flex-direction: row;
    justify-content: center;
    gap: 16px;

    ${mq('max', '768px')} {
      flex-direction: column;
      align-items: center;

      > a,
      > button {
        width: 280px;
        max-width: 100%;
      }
    }
  }
`

const BookCTA = () => (
  <BookCTAWrapper>
    <Header2 align="center">Book a service today</Header2>
    <div className="cta-buttons">
      <Button large color={c.cobalt} padding="14px 80px" path="/book">
        Book Now
      </Button>
      <LinkButton className="app-install-prompt" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer" outline large color="#000">
        Download the App
      </LinkButton>
    </div>
  </BookCTAWrapper>
)

export default BookCTA
